import React from 'react';
import { Link } from 'react-router-dom';

const Navbar = ({ language = "en" }) => {
  const text = {
    en: {
      home: "Home Page",
      tennismasterapp:"AI Coach",
      privacy: "Privacy Policy",
    },

    zh: {
      home: "首   页",
      tennismasterapp:"AI 网球教练",
      privacy: "隐 私 政 策",
    },
  };

  const t = text[language];

  return (
    <nav
      style={{
        display: "flex",
        justifyContent: "center",
        fontSize: "18px",
      }}
    >
      <ul
        style={{
          display: "flex",
          listStyleType: "none",
          margin: "0",
          padding: "0",
        }}
      >
        <li style={{ marginRight: "20px" }}>
          <Link to="/">{t.home}</Link>
        </li>

        <li style={{ marginRight: "20px" }}>
          <Link to="/tennismasterapp">{t.tennismasterapp}</Link>
        </li>

        <li style={{ marginRight: "20px" }}>
          <Link to="/privacy">{t.privacy}</Link>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
